package es.subastia.ui.model

import es.subastia.domain.model.AuctionProcedureType

data class AuctionUiModel(
    val auctionId: String,
    val title: String,
    val description: String? = null,
    val currentPrice: Double? = null,
    val basePrice: Double? = null,
    val imageUrl: String? = null,
    val dates: AuctionDatesUiModel,
    val authority: AuctionAuthorityUiModel? = null,
    val location: String? = null,
    val category: String? = null,
    val type: String? = null,
    val procedureType: AuctionProcedureType = AuctionProcedureType.UNKNOWN,
    val offersCount: Int = 0,
    
    // Detailed Fields
    val accountExpediente: String? = null,
    val aiSummary: String? = null,
    val appraisalValue: Double,
    val auctionValue: Double,
    val address: String?,
    val code: String? = null,
    val email: String? = null,
    val fax: String? = null,
    val model: String? = null,
    val phone: String? = null,
    val bidStep: Double,
    val boeAnnouncement: String? = null,
    val boeId: String? = null,
    val catastralRef: String? = null,
    val city: String? = null,
    val claimedAmount: Double,
    val depositAmount: Double,
    val hasLots: Boolean = false,
    val isGoodOpportunity: Boolean = false,
    val lotId: Int? = null,
    val minBid: Double? = null,
    val portalUrl: String,
    val province: String? = null,
    val status: String? = null,
    val updatedAt: String? = null,
    val lots: List<LotUiModel> = emptyList()
)

data class AuctionDatesUiModel(
    val startDate: String?,
    val endDate: String?
)

data class AuctionAuthorityUiModel(
    val name: String? = null,
    val email: String? = null,
    val phone: String? = null
)
